// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '次のような完了日を使用して再試行してください: ' + p['dateExample'] + '。',
  chart_labelGroup: () => 'グループ',
  chart_labelSeries: () => '系列',
  chart_labelValue: () => '値',
  checkboxSet_requiredMessageDetail: () => '必須',
  checkbox_requiredMessageDetail: () => '必須',
  close: () => '閉じる',
  collection_noData: () => '表示するデータがありません',
  collection_selectAllRows: () => 'すべての行を選択',
  collection_selectRow: (p: { ROW_NAME: string }) => '行' + p['ROW_NAME'] + 'を選択',
  collection_sortDisabled: () => 'ソート不可',
  collection_sortEnabled: () => 'ソート可能',
  confirmation: () => '確認',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + '/' + p['totalCount'],
  dataVisualization_noData: () => '表示するデータがありません',
  dataVisualization_stateSelected: () => '選択済',
  dataVisualization_stateUnselected: () => '未選択',
  error: () => 'エラー',
  expandableList_expandCollapseInstructionText: () => '展開および縮小には矢印キーを使用します',
  expandableList_groupCollapse: () => '縮小済',
  expandableList_groupExpand: () => '展開済',
  filePicker_addFiles: () => 'ファイルの追加',
  filePicker_dropzonePrimaryText: () => 'ドラッグ・アンド・ドロップ',
  filePicker_dropzoneSecondaryText: () => 'ファイルを選択するか、ここにドロップします',
  filePicker_dropzoneSecondaryTextMultiple: () => 'ファイルを選択するか、ここにドロップします',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    '次のタイプのファイルはアップロードできません: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => '一度に1つのファイルをアップロードします',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'タイプが' + p['fileType'] + 'のファイルはアップロードできません',
  filePicker_unknownFileTypeUploadError: () => '不明',
  formControl_clear: () => 'クリア',
  formControl_day: () => '日',
  formControl_helpAvailable: () => 'ヘルプが使用可能',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    ((({ one: '1文字' }) as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('ja').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('ja').format(p['CHARACTER_LIMIT']) + '文字') +
    'の制限に達しました。',
  formControl_loading: () => 'ロード中',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '最大長' + p['MAX_LENGTH'] + 'を超えています。',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + '文字残っています。',
  formControl_month: () => '月',
  formControl_readOnly: () => '読取り専用',
  formControl_requiredMessageDetail: () => '値を入力してください。',
  formControl_year: () => '年',
  gantt_labelDate: () => '日付',
  gantt_labelEnd: () => '終了',
  gantt_labelLabel: () => 'ラベル',
  gantt_labelRow: () => '行',
  gantt_labelStart: () => '開始',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '。一致するセクションが見つかりませんでした。',
  indexer_keyboardInstructionText: () => '[Enter]を押して値を選択します。',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    p['FROM_SECTION'] + 'から' + p['TO_SECTION'] + 'まで。',
  indexer_touchInstructionText: () =>
    'ダブル・タップしてホールドし、ジェスチャ・モードを開始した後、上下にドラッグして値を調整します。',
  info: () => '情報',
  inputDateMask_date_cleared: () => 'クリアした日付',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => '空',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputNumber_converterParseError: () => '数値を入力してください。',
  inputNumber_decrease: () => '減らす',
  inputNumber_increase: () => '増やす',
  inputPassword_hidden: () => 'パスワード非表示',
  inputPassword_hide: () => 'パスワードの非表示',
  inputPassword_show: () => 'パスワードの表示',
  list_suggestion: () => '提案',
  messageToast_allMessagesClosed: () => 'すべての通知メッセージが閉じられています。',
  message_close: () => '閉じる',
  message_confirmation: () => '成功',
  message_error: () => 'エラー',
  message_info: () => '情報',
  message_navigationFromMessagesRegion: () =>
    'メッセージ・リージョンに入ります。フォーカスされていた前の要素に戻るには、[F6]を押してください。',
  message_navigationToMessagesRegion: () =>
    'メッセージ・リージョンに新しいメッセージがあります。最新のメッセージ・リージョンに移動するには、[F6]を押してください。',
  message_warning: () => '警告',
  noData_message: () => '表示するアイテムはありません',
  overflowItemLabel: () => '追加タブ',
  plural_separator: () => ', ',
  progressIndeterminate: () => '進行中',
  radio_helpForRadio: () => 'ラジオ・ボタンのヘルプ',
  radio_requiredMessageDetail: () => '値を選択してください。',
  selectMultiple_apply: () => '適用',
  selectMultiple_back: () => '戻る',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    '[Back Space]または[Delete]を押して、選択した値を削除します。',
  selectMultiple_selectedValues: () => '選択された値',
  selectMultiple_showSelectedValues: () => '選択された値のみを表示します。',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + '個の値が選択されました。',
  select_addToList: () => 'リストに追加',
  select_addToListAvailable: () => 'リストに追加が使用可能',
  select_moreSearchOptions: () => '詳細検索オプション',
  select_moreSearchOptionsAvailable: () => '詳細検索オプションが使用可能',
  select_noMatchesFound: () => '一致する検索文字列が見つかりませんでした。',
  select_oneMatchFound: () => '一致が1つ見つかりました',
  select_requiredMessageDetail: () => '値を選択してください。',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '件の一致が見つかりました',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + '件以上の一致が見つかりました',
  selector_selected: () => 'チェック・ボックス(選択済)',
  selector_unselected: () => 'チェック・ボックス(未選択)',
  tabBarNavigationList_removeCueText: () => '削除可能',
  timeComponent_tooltipZoomIn: () => 'ズームイン',
  timeComponent_tooltipZoomOut: () => 'ズームアウト',
  train_current: () => '現在',
  train_message_type: () => 'メッセージ・タイプ',
  train_not_visited: () => '未アクセス',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'ステップ' + p['currentStep'] + '/' + p['numberOfSteps'],
  train_visited: () => 'アクセス済',
  userAssistance_learnMore: () => 'さらに学ぶ',
  userAssistance_required: () => '必須',
  viz_drillable: () => 'ドリル可能',
  warn: () => '警告'
};
export default bundle;
